import React from 'react';
import { Avatar } from 'antd';
import classNames from 'classnames';
import { ColorGenerator } from '../../services';

interface Props {
	user: Partial<Bringg.User>;
	className?: string;
}

export const getInitials = name =>
	name
		? name
				.split(' ')
				.map(n => (n[0] ? n[0].toUpperCase() : n))
				.join('')
		: '';

const UserAvatarInfo = ({ user, className }: Props) => {
	const initials = getInitials(user.name);

	return (
		<div className={classNames('user-info', className)}>
			<Avatar
				src={user.profile_image}
				style={{ backgroundColor: ColorGenerator.getPersistentColorByString(initials) }}
			>
				{initials}
			</Avatar>
			<div className="user-info-name">{user.name}</div>
		</div>
	);
};

export default UserAvatarInfo;
